import React, { type FC } from "react";
import { useUscSelector } from "../../../../redux/store";
import type { FullQuickSpecConfigType } from "../../../../../shared-logic/utils/uscUtils";
import * as Styles from "./EcoLabelExtraSpec.styles";
import { getEcoLabelSrc } from "../../../../utils/specUtils";

type Props = { spec: FullQuickSpecConfigType };
const EcolabelExtraSpec: FC<Props> = ({ spec }) => {
    const commonSettings = useUscSelector((state) => state.commonSettings);
    return (
        <Styles.Wrapper>
            {spec.value}
            <Styles.EcoIcon width={17} height={17} url={getEcoLabelSrc(commonSettings, spec.valueCode || "")} />
        </Styles.Wrapper>
    );
};
export default EcolabelExtraSpec;
